import { combineReducers } from 'redux';
import { merge } from 'lodash'
import { normalize, schema } from 'normalizr';

// Define a segmaps schema
const segmapSchema = new schema.Entity('segmaps', {}, { idAttribute: 'id' });
const segmapListSchema = [segmapSchema];

const defaultSegmapParams = {
  segmapFetched: false,
  searchFetched: false,
  isDelFetched: false,
  createTitle: 'Create New Segmap',
  createSubmitButtonText: 'Save Segmap',
  cloneTitle: 'Create New Segmap',
  cloneSubmitButtonText: 'Save Segmap',
  editTitle: 'Edit Segmap',
  editSubmitButtonText: 'Update Segmap'
}


function byId(state = {}, action) {
  if (action.type === 'SAVED_SEGMAP') {
    const segmapID = action.payload.id;
    return {
      ...state,
      [segmapID]: action.payload
    }
  }
  if (action.type === 'FETCHED_SEGMAP') {
    const normalizedSegmap = normalize(action.payload, segmapListSchema);
    return merge({}, state, normalizedSegmap.entities.segmaps)
  }
  if (action.type === 'DELETED_SEGMAP') {
    if (action.payload.msg === "Success") {
      const segmapID = action.payload.id;
      return {
        ...state,
        [segmapID]: {
          ...state[segmapID],
          status: 0
        }
      }
    } else {
      return state
    }
  }
  if (action.type === 'RESET_DATA') {
    return {}
  } else {
    return state
  }
}

function searchResults(state = {}, action) {
  if (action.type === 'STORE_SEARCH_SEGMAP_RESULT') {
    const normalizedSegmap = normalize(action.payload, segmapListSchema);
    return merge({}, normalizedSegmap.entities.segmaps)
  }
  if (action.type === 'RESET_DATA') {
    return {}
  } else {
    return state
  }
}

function filterResults(state = {}, action) {
  if (action.type === 'FILTER_ITEMS') {
    const col = action.payload.col;
    return {
      ...state,
      [col]: action.payload
    }
  }
  if (action.type === 'RESET_DATA') {
    return {}
  } else {
    return state
  }
}

function savedCompanyDetails(state = {}, action) {
  if (action.type === 'SAVED_COMPANY_DETAILS') {
    if (action.payload.type === "success") {
      if (action.payload.data) {
        return action.payload.data
      } else {
        return state
      }

    } else {
      return state
    }
  } else {
    return state
  }
}

function notifications(state = {}, action) {
  if (action.type === 'SAVED_SEGMAP') {

    return {
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        save: {
          status: (action.txn === "success" || action.txn === "Success") ? 'success' : 'error',
          msg: action.msg || action.txn
        }
      }
    }
  }
  if (action.type === 'DELETED_SEGMAP') {
    return {
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        delete: {
          status: action.payload.msg === "Success" ? 'success' : 'error',
          msg: action.payload.msg
        }
      }
    }
  }
  if (action.type === 'NOTIFICATION_DONE_SEGMAP') {
    const { id, type } = action.payload
    // Remove the 'id' element from state
    const { [id]: idValue, ...restOfState } = state;
    // Remove the 'type' from the 'id' element
    const { [type]: removedValue, ...restOfId } = idValue;
    // Merge back together
    const finalState = { ...restOfState, [id]: restOfId };
    return finalState

  } else {
    return state
  }
}


function params(state = defaultSegmapParams, action) {
  if (action.type === 'FETCHED_SEGMAP') {
    return {
      ...state,
      segmapFetched: true,
      isFetching: false
    }
  } if (action.type === 'SEARCH_SEGMAP') {
    return {
      ...state,
      searchFetched: false,
      isSearching: true,
    }
  }
  if (action.type === 'STORE_SEARCH_SEGMAP_RESULT') {
    return {
      ...state,
      searchFetched: true,
      isSearching: false,
    }
  }
  if (action.type === 'DELETED_SEGMAP') {
    return {
      ...state,
      isDelFetched: true
    }
  } if (action.type === 'SET_SEGMAP_FETCH_OFF') {
    return {
      ...state,
      isDelFetched: false
    }
  }
  if (action.type === 'RESET_DATA') {
    return defaultSegmapParams
  } else {
    return state
  }
}

const segmap = combineReducers({
  byId,
  notifications,
  searchResults,
  params,
  filterResults,
  savedCompanyDetails
});

export default segmap;

